module.exports = __webpack_public_path__ + "img/guoqi.2a435123.png";